export default class JapanidxTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/japanidxtrend")
      .then(res => res.json());
  }
}